import { Backdrop, CircularProgress, Typography, Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "@store/hooks";

/**
 * WorkspaceLoadingSpinner - A full-screen loading spinner that shows when workspace data is being fetched
 */
const WorkspaceLoadingSpinner = () => {
  const isLoading = useAppSelector(
    (state) => state.loading.isWorkspaceDataLoading
  );
  const { pathname } = useLocation();
  // This data (readings/canvases/papers) backs the annogram reader/canvas
  // view. Don't blanket-cover unrelated routes (/profile, /files, /help,
  // /workspaces) — they have their own data and loading states, and a
  // background workspace fetch shouldn't block them.
  const onWorkspaceView = pathname.startsWith("/annogram");

  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: "rgba(0, 0, 0, 0.7)",
      }}
      open={isLoading && onWorkspaceView}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap={2}
      >
        <CircularProgress color="inherit" size={60} thickness={4} />
        <Typography
          variant="h6"
          component="div"
          sx={{
            fontWeight: "medium",
            textAlign: "center",
          }}
        >
          Loading workspace data...
        </Typography>
        <Typography
          variant="body2"
          component="div"
          sx={{
            opacity: 0.8,
            textAlign: "center",
          }}
        >
          Fetching canvases, readings, and papers
        </Typography>
      </Box>
    </Backdrop>
  );
};

export default WorkspaceLoadingSpinner;
